import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { MobilityBenefitOptionsDTOTaxationTypeEnum } from 'probonio-shared-ui/api';
import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';

export class MobilityBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'mobilityMonthlyLimit',
      accessorFn: value => value.mobilityOptions?.monthlyLimit,
      header: 'MOBILITY.fields.monthlyLimit',
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
    {
      id: 'mobilityTaxationType',
      accessorFn: value => value.mobilityOptions?.taxationType,
      header: 'MOBILITY.fields.taxationTypeColumn',
      renderer: value =>
        value === MobilityBenefitOptionsDTOTaxationTypeEnum.Taxable ? (
          <CheckIcon color="success" />
        ) : value === MobilityBenefitOptionsDTOTaxationTypeEnum.TaxFree ? (
          <CloseIcon color="error" />
        ) : null,
    },
  ];
}
